export default __webpack_public_path__ + "static/media/2021_Tao_et_al_2021_EcologyEvolution.a94f20a4.pdf";